import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {borderRadius, pointer} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useTranslation} from "@pg-mono/i18n";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferBoxBase} from "../../../../atoms/OfferBoxBase";
import {RegionType} from "../../../../region/types/RegionType";
import {getHomeLinkClick} from "../../../../tracking/algolytics_hits/click_actions/gethome_link_click";
import {ViewType} from "../../../../view_type/ViewType";
import {getOfferTypeNamePlural} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";

const ghLogo = require("../../../images/gethome_logo_white.svg");

interface IProps {
    offerType: OfferType | undefined;
    region: {id: number | undefined; name: string | undefined; slug: string | undefined; parentSlug: string | undefined; type: RegionType | undefined};
}

// TODO: rebrand
export const GetHomeLinkingBox = (props: IProps) => {
    const {offerType, region} = props;
    const texts = ["Zobacz", "najnowsze oferty z", "rynku wtórnego", "w lokalizacji", "mieszkania i domy"];
    if (offerType) {
        texts.push(getOfferTypeNamePlural(offerType));
    }

    const translations = useTranslation(texts);
    const see = translations ? translations[0] : texts[0];
    const newOffersFrom = translations ? translations[1] : texts[1];
    const afterMarket = translations ? translations[2] : texts[2];
    const inLocation = translations ? translations[3] : texts[3];
    const housesAndFlats = translations ? translations[4] : texts[4];
    const offerTypeNamePlural = translations && offerType ? translations[5] : "";

    const offerTypeSlug = translateOfferType(offerType);
    const permalinkBase = `${rpAppLink.external.getHome}${offerTypeSlug}${offerType == OfferType.HOUSE || offerType == OfferType.FLAT ? "/na-sprzedaz/" : "/"}`;

    const redirectToGH = () => {
        // algolytics hit
        getHomeLinkClick(ViewType.OFFER_LIST);
        let regionSlug =
            (region.type && region.slug && region.type === RegionType.DISTRICT) || region.type === RegionType.NEIGHBORHOOD
                ? (region.slug?.replace("-", "/") ?? "")
                : (region.slug ?? "");

        if (region.parentSlug && region.slug?.includes(region.parentSlug)) {
            const subRegion = region.slug?.replace(`${region.parentSlug}-`, "") || "";
            regionSlug = `${region.parentSlug}/${subRegion}`;
        }
        const query = {
            utm_source: "rynek_pierwotny",
            utm_medium: "offer_list",
            utm_campaign: "crosspromo_rynek_pierwotny"
        };
        const url = regionSlug ? `${permalinkBase}${regionSlug.toLowerCase()}/` : permalinkBase;
        const urlWithQuery = appendQueryString(url, query);
        window.open(urlWithQuery, "_blank");
    };

    return (
        <GetHomeBox onClick={redirectToGH} css={pointer}>
            <div css={boxContent}>
                <MapMarkerOutlineIcon size="2.6" css={marker} wrapperColor="#fff" wrapperSize="4" />
                <img alt="getHome" width={205} height={47} src={ghLogo} loading="lazy" css={logo} />
                <Text variant="body_copy_1" css={ghCopy} className="bt">
                    {see} {newOffersFrom}&nbsp;<span>{afterMarket}</span> {region.name ? `${inLocation} ${region.name}` : ""}
                </Text>
            </div>
            <Button css={buttonStyle} variant="stretched_primary">
                <span className="bt">
                    {see} {offerType ? offerTypeNamePlural : housesAndFlats}
                </span>
            </Button>
        </GetHomeBox>
    );
};

const translateOfferType = (type: OfferType | undefined) => {
    switch (type) {
        case OfferType.FLAT:
            return "mieszkania";
        case OfferType.HOUSE:
            return "domy";
        default:
            return "nieruchomosci";
    }
};

const background = require("../../../images/gethome_background.png");

const GetHomeBox = styled(OfferBoxBase)`
    background-image: url(${background});
    height: 100%;
    width: 100%;
    min-height: 42rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    justify-content: space-between;
`;

const boxContent = css`
    display: flex;
    padding: 1.5rem;
    flex-direction: column;
`;

const buttonStyle = css`
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
    background-color: white;
    color: #9069c0; // gh primary
    border: 0 none;
`;

const ghCopy = css`
    color: white;
    text-align: center;
    max-width: 300px;
    margin: 15px auto;

    span {
        font-weight: 700;
        white-space: nowrap;
    }
`;

const marker = css`
    margin: 15px 10px 0 auto;
`;

const logo = css`
    margin: 60px auto 25px;
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {borderRadius, pointer} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useTranslation} from "@pg-mono/i18n";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferBoxBase} from "../../../../atoms/OfferBoxBase";
import {RegionType} from "../../../../region/types/RegionType";
import {getHomeLinkClick} from "../../../../tracking/algolytics_hits/click_actions/gethome_link_click";
import {ViewType} from "../../../../view_type/ViewType";
import {getOfferTypeNamePlural} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";

const ghLogo = require("../../../images/gethome_logo_white.svg");

interface IProps {
    offerType: OfferType | undefined;
    region: {id: number | undefined; name: string | undefined; slug: string | undefined; parentSlug: string | undefined; type: RegionType | undefined};
}

// TODO: rebrand
export const GetHomeLinkingBox = (props: IProps) => {
    const {offerType, region} = props;
    const texts = ["Zobacz", "najnowsze oferty z", "rynku wtórnego", "w lokalizacji", "mieszkania i domy"];
    if (offerType) {
        texts.push(getOfferTypeNamePlural(offerType));
    }

    const translations = useTranslation(texts);
    const see = translations ? translations[0] : texts[0];
    const newOffersFrom = translations ? translations[1] : texts[1];
    const afterMarket = translations ? translations[2] : texts[2];
    const inLocation = translations ? translations[3] : texts[3];
    const housesAndFlats = translations ? translations[4] : texts[4];
    const offerTypeNamePlural = translations && offerType ? translations[5] : "";

    const offerTypeSlug = translateOfferType(offerType);
    const permalinkBase = `${rpAppLink.external.getHome}${offerTypeSlug}${offerType == OfferType.HOUSE || offerType == OfferType.FLAT ? "/na-sprzedaz/" : "/"}`;

    const redirectToGH = () => {
        // algolytics hit
        getHomeLinkClick(ViewType.OFFER_LIST);
        let regionSlug =
            (region.type && region.slug && region.type === RegionType.DISTRICT) || region.type === RegionType.NEIGHBORHOOD
                ? (region.slug?.replace("-", "/") ?? "")
                : (region.slug ?? "");

        if (region.parentSlug && region.slug?.includes(region.parentSlug)) {
            const subRegion = region.slug?.replace(`${region.parentSlug}-`, "") || "";
            regionSlug = `${region.parentSlug}/${subRegion}`;
        }
        const query = {
            utm_source: "rynek_pierwotny",
            utm_medium: "offer_list",
            utm_campaign: "crosspromo_rynek_pierwotny"
        };
        const url = regionSlug ? `${permalinkBase}${regionSlug.toLowerCase()}/` : permalinkBase;
        const urlWithQuery = appendQueryString(url, query);
        window.open(urlWithQuery, "_blank");
    };

    return (
        <GetHomeBox onClick={redirectToGH} css={pointer}>
            <div css={boxContent}>
                <MapMarkerOutlineIcon size="2.6" css={marker} wrapperColor="#fff" wrapperSize="4" />
                <img alt="getHome" width={205} height={47} src={ghLogo} loading="lazy" css={logo} />
                <Text variant="body_copy_1" css={ghCopy} className="bt">
                    {see} {newOffersFrom}&nbsp;<span>{afterMarket}</span> {region.name ? `${inLocation} ${region.name}` : ""}
                </Text>
            </div>
            <Button css={buttonStyle} variant="stretched_primary">
                <span className="bt">
                    {see} {offerType ? offerTypeNamePlural : housesAndFlats}
                </span>
            </Button>
        </GetHomeBox>
    );
};

const translateOfferType = (type: OfferType | undefined) => {
    switch (type) {
        case OfferType.FLAT:
            return "mieszkania";
        case OfferType.HOUSE:
            return "domy";
        default:
            return "nieruchomosci";
    }
};

const background = require("../../../images/gethome_background.png");

const GetHomeBox = styled(OfferBoxBase)`
    background-image: url(${background});
    height: 100%;
    width: 100%;
    min-height: 42rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    justify-content: space-between;
`;

const boxContent = css`
    display: flex;
    padding: 1.5rem;
    flex-direction: column;
`;

const buttonStyle = css`
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
    background-color: white;
    color: #9069c0; // gh primary
    border: 0 none;
`;

const ghCopy = css`
    color: white;
    text-align: center;
    max-width: 300px;
    margin: 15px auto;

    span {
        font-weight: 700;
        white-space: nowrap;
    }
`;

const marker = css`
    margin: 15px 10px 0 auto;
`;

const logo = css`
    margin: 60px auto 25px;
`;
